import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { FiPackage, FiArrowRight } from 'react-icons/fi';
import { getMyOrders } from '../services/api';

const statusColors = {
  pending:    'bg-yellow-100 text-yellow-700',
  confirmed:  'bg-blue-100 text-blue-700',
  processing: 'bg-purple-100 text-purple-700',
  shipped:    'bg-indigo-100 text-indigo-700',
  delivered:  'bg-green-100 text-green-700',
  cancelled:  'bg-red-100 text-red-700',
};

export default function OrdersPage() {
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getMyOrders()
      .then(res => setOrders(res.data))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div className="max-w-3xl mx-auto px-4 py-10 space-y-4">
      {[...Array(3)].map((_, i) => <div key={i} className="skeleton h-24 rounded-2xl" />)}
    </div>
  );

  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <h1 className="font-display text-4xl font-bold text-yamass-black mb-8">My Orders</h1>

      {orders.length === 0 ? (
        <div className="text-center py-20">
          <FiPackage size={56} className="text-gray-200 mx-auto mb-5" />
          <p className="text-gray-400 text-lg mb-6">You haven't placed any orders yet</p>
          <Link to="/shop" className="inline-flex items-center gap-2 bg-yamass-black text-white px-6 py-3 rounded-full text-sm font-semibold hover:bg-yamass-accent transition-colors">
            Start Shopping <FiArrowRight size={14} />
          </Link>
        </div>
      ) : (
        <div className="space-y-4">
          {orders.map(order => (
            <Link
              key={order._id}
              to={`/orders/${order._id}`}
              className="block bg-yamass-cream rounded-2xl p-5 hover:shadow-md transition-shadow"
            >
              <div className="flex items-start justify-between gap-4">
                <div>
                  <p className="text-xs text-gray-400 mb-1">Order #{order._id.slice(-8).toUpperCase()}</p>
                  <p className="text-sm text-gray-600">
                    {order.orderItems.length} item{order.orderItems.length > 1 ? 's' : ''} ·{' '}
                    <span className="font-semibold text-yamass-black">৳{order.totalPrice.toLocaleString()}</span>
                  </p>
                  <p className="text-xs text-gray-400 mt-1">
                    {new Date(order.createdAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' })}
                  </p>
                </div>
                <div className="flex items-center gap-3">
                  <span className={`text-xs font-medium px-3 py-1 rounded-full capitalize ${statusColors[order.orderStatus] || 'bg-gray-100 text-gray-600'}`}>
                    {order.orderStatus}
                  </span>
                  <FiArrowRight size={16} className="text-gray-400" />
                </div>
              </div>

              {/* Item thumbnails */}
              <div className="flex gap-2 mt-4">
                {order.orderItems.slice(0, 4).map((item, i) => (
                  <div key={i} className="w-12 h-12 rounded-lg overflow-hidden bg-white flex-shrink-0">
                    {item.image
                      ? <img src={item.image} alt={item.name} className="w-full h-full object-cover" />
                      : <div className="w-full h-full flex items-center justify-center text-lg">👕</div>
                    }
                  </div>
                ))}
                {order.orderItems.length > 4 && (
                  <div className="w-12 h-12 rounded-lg bg-white flex items-center justify-center text-xs text-gray-400 font-medium flex-shrink-0">
                    +{order.orderItems.length - 4}
                  </div>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
